import React, { useState } from "react";
import "./App.css";

function App() {
  const [ticker, setTicker] = useState("");
  const [expiration, setExpiration] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const runSimulation = async () => {
    if (!ticker || !expiration) {
      setError("fill in both fields");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const res = await fetch(
        "https://monte-simulation-production.up.railway.app/simulate",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ticker_symbol: ticker,
            expiration_date: expiration,
          }),
        },
      );

      const result = await res.json();

      if (result.error) {
        setError(result.error);
        setData(null);
      } else {
        setData(result);
      }
    } catch (err) {
      setError("backend not running? start it with uvicorn main:app --reload");
    }

    setLoading(false);
  };

  // green = positive EV, red = negative, blue = neutral
  const getColor = (ratio) => {
    if (ratio > 0.25) return "#16a34a";
    if (ratio > 0.05) return "#4ade80";
    if (ratio > -0.05) return "#1e40af";
    if (ratio > -0.25) return "#f87171";
    return "#dc2626";
  };

  return (
    <div className="app-container">
      <h1 className="title">options simulator</h1>

      <div className="input-section">
        <input
          type="text"
          placeholder="ticker"
          value={ticker}
          onChange={(e) => setTicker(e.target.value.toUpperCase())}
        />
        <input
          type="date"
          value={expiration}
          onChange={(e) => setExpiration(e.target.value)}
        />
        <button className="button" onClick={runSimulation} disabled={loading}>
          {loading ? "loading..." : "run"}
        </button>
      </div>

      {error && <p style={{ color: "#f87171", marginTop: "16px" }}>{error}</p>}

      {data && (
        <>
          <h2>
            {data.ticker} — ${data.spot}
          </h2>

          <div className="chain-grid">
            <div>
              <h3>PUTS</h3>
              <table className="strike-table">
                <thead>
                  <tr>
                    <th>Strike</th>
                    <th>BE</th>
                    <th>ITM %</th>
                    <th>Profit %</th>
                    <th>EV</th>
                  </tr>
                </thead>
                <tbody>
                  {data.puts.map((row, i) => (
                    <tr key={i}>
                      <td>${row.strike}</td>
                      <td>${row.breakeven}</td>
                      <td>{(row.itm * 100).toFixed(1)}%</td>
                      <td>{(row.profit * 100).toFixed(1)}%</td>
                      <td
                        style={{
                          backgroundColor: getColor(row.mispricing_ratio),
                        }}
                      >
                        ${row.ev}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div>
              <h3>CALLS</h3>
              <table className="strike-table">
                <thead>
                  <tr>
                    <th>Strike</th>
                    <th>BE</th>
                    <th>Profit %</th>
                    <th>ITM %</th>
                    <th>EV</th>
                  </tr>
                </thead>
                <tbody>
                  {data.calls.map((row, i) => (
                    <tr key={i}>
                      <td>${row.strike}</td>
                      <td>${row.breakeven}</td>
                      <td>{(row.profit * 100).toFixed(1)}%</td>
                      <td>{(row.itm * 100).toFixed(1)}%</td>
                      <td
                        style={{
                          backgroundColor: getColor(row.mispricing_ratio),
                        }}
                      >
                        ${row.ev}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default App;
